export const sv = {
  buttons: {
    login: "Logga in",
    logout: "Logga ut",
    back: "Tillbaka",
    create: "Skapa",
    cancel: "Avbryt",
    close: "Stäng",
    forgotPassword: "Glömt ditt lösenord?",
    createTicket: "Skapa nytt ärende",
  },
  labels: {
    email: "E-post",
    password: "Lösenord",
    confirmPassword: "Bekräfta lösenord",
    createPassword: "Skapa lösenord",
    orders: "Ordrar",
    tickets: "Ärenden",
    passwordLength: "Lösenordet måste bestå av minst 6 tecken.",
    title: "Rubrik",
    orderNumber: "Ordernummer",
    ticketNumber: "Ärendenummer",
    phoneNumber: "Telefonnummer",
    category: "Kategori",
    categoryPlaceholder: "Välj kategori",
    componentName: "Komponent",
    faultSymptom: "Felbeskrivning",
    replacementMaterialWanted: "Ersättningsmaterial önskas",
    replacementMaterialHint: "Observera: Ersättningsmaterial faktureras och krediteras om ärendet bedöms som garanti efter analys.",
    electronics: "Elektronik",
    mechanics: "Mekanik",
    materialInDelivery: "Material i leverans",
    image: "Bild",
    yourName: "Ditt namn",
    customer: "Kund",
    reportedBy: "Rapporterad av",
    created: "Skapad",
    ticket: "Ärende",
    noTickets: "Inga ärenden hittades för denna kund.",
    yes: "Ja",
    no: "Nej",
    status: "Status",
    contact: "Kontakt",
    comment: "Statusuppdatering",
    lastUpdated: "Senast uppdaterat",
    ticketDetails: "Ärendedetaljer",
  },
  loadingMore: "Hämtar fler ordrar...",
  loadingMoreTickets: "Hämtar fler ärenden...",
  texts: {
    welcomeMessage: "Välkommen till Kundportalen,",
    welcomeMessageWithoutUserTitle: "Välkommen till Kundportalen!",
    customerPortalBurdy: "Kundportal - Burdy",
    customerPortalHisselektronik: "Kundportal - Hisselektronik",
  },
  success: {
    login: "Välkommen",
    logout: "Du är nu utloggad!",
    downloaded: "Mappen laddades ner framgångsrikt!",
    ticketCreated: "Ärende {{number}} skapat!",
  },
  warning: {
    customerNotFound: "Ärendet skapades men kunden \"{{customer}}\" hittades inte i systemet. Kund-fältet är tomt i SharePoint.",
  },
  error: {
    swr: "Något gick fel.",
    userFetch: "Misslyckades med att hämta användare",
    orders: "Misslyckades med att hämta ordrar",
    tickets: "Misslyckades med att hämta ärenden",
    zip: "Misslyckades med att ladda ned mappens innehåll",
    passwordMatch: "Lösenorden matchar inte.",
    ticketCreate: "Misslyckades med att skapa ärendet.",
  },
  info: {
    tokenExpired: "Din session har gått ut. Logga in igen.",
    firstLogin:
      "Välkommen! Vänligen ange ett nytt lösenord för att kunna logga in.",
  },
};
